import ky from "ky";
import platform from "platform";
import {
  addFieldData,
  addSubStep,
  addUserSelected,
  allInfoUser,
  cgu,
  codeSms,
  deleteSubStep,
  detailPatient,
  emptyBreadcrumbs,
  faq,
  filesDownload,
  infoWaitingRoom,
  isFirstConnectionPatientArea,
  isPatientArea,
  linkedAccounts,
  listPatients,
  localeSetLanguage,
  myAppointments,
  myFiles,
  myHistory,
  myParams,
  nextStep,
  originQrCode,
  removeUserSelected,
  replaceSubStep,
  resetMessageWithCode,
  resetUserData,
  resetUsersSelected,
  secretUpdate,
  setActiveStep,
  setConfig,
  setFetcherAppointment,
  setFetcherUrls,
  setItemBreadcrumbs,
  setMessage,
  setMessageWithCode,
  setPayment,
  setPaymentDetails,
  setReturnedValue,
  setShowCodePrioritaire,
  setSocialSecurity,
  setStepByPass,
  setSteps,
  setUserKey,
  showDialogSms,
  startLoading,
  stopLoading,
  userArea
} from "../actions";
import { store } from "../store";
import instance, {
  createLooperStep,
  createStep,
  searchSelfRemoveSubStep,
  searchStep,
  searchStepByCode
} from "./scenario-manager";
import {
  formatQuestion,
  formatWaitingRoomPersons,
  formatWaitingRoomPersonsExternal
} from "./formatter";
import Ouinon from "../components/question/Ouinon";
import QSelect from "../components/question/QSelect";
import SummaryReport from "../components/SummaryReport";
import ConfirmationSms from "../components/subscribe/ConfirmationSms";
import {
  GROUP_QUESTION_RESPONSE,
  STEP_CODE_IDENTIFY,
  STEP_CODE_QUESTION,
  STEP_SEPARATOR
} from "./constants";
import breadcrumbs from "./breadcrumbs";
import Questionnaire from "../components/question/Questionnaire";
import GoToLink from "../components/question/GoToLink";
import { getUserData, onLoggedIn } from "./user";
import ua from "./ua";
import "url-search-params-polyfill";
import { RESET_APP } from "../actions/action-types";
import responseChecker from "./responseChecker";
import { hash } from "./session";
import { getDefaultLocale, translator } from "./i18n";
import { browserName } from "react-device-detect";

const uniqid = require("uniqid");

let isInitialized = false;
const initialValues = {};
export const initValues = () => {
  if (!isInitialized) {
    document.cookie = "user_connected=" + false;
    const searchParams = new URLSearchParams(window.location.search);
    const values = [
      { urlKey: "idc", stateKey: "idc", default: "" },
      { urlKey: "typewidget", stateKey: "widgetType", default: "normal" }, // anest , question, question
      { urlKey: "idquestion", stateKey: "idquestion" },
      { urlKey: "idquestion", stateKey: "originalQuestionId" },
      { urlKey: "token_rdv", stateKey: "rdvToken" },
      { urlKey: "optin", stateKey: "optIn" },
      { urlKey: "idlieu", stateKey: "idlieu" },
      { urlKey: "idp", stateKey: "idp" },
      { urlKey: "idactivite", stateKey: "idactivite" },
      { urlKey: "lang", stateKey: "lang", default: getDefaultLocale() },
      { urlKey: "mode", stateKey: "mode" }, // compte
      { urlKey: "provenance", stateKey: "provenance" },
      { urlKey: "from", stateKey: "from" },
      { urlKey: "appointment", stateKey: "appointment", default: "" },
      {
        urlKey: "status_bloque_bouton",
        stateKey: "status_bloque_bouton",
        default: "nop"
      },
      { urlKey: "cookie", stateKey: "cookie", default: uniqid() },
      { urlKey: "iframe", stateKey: "iframe", default: false },
      { urlKey: "noClose", stateKey: "noClose", default: false },
      { urlKey: "noBG", stateKey: "noBG", default: false },
      { urlKey: "dayId", stateKey: "dayId", default: "" },
      { urlKey: "publicKey", stateKey: "publicKey", default: "" },
      { urlKey: "userKey", stateKey: "userKey", default: "" },
      { urlKey: "partenaire", stateKey: "partenaire", default: "" },
      { urlKey: "specialite", stateKey: "specialite", default: "" },
      { urlKey: "noModal", stateKey: "noModal", default: false },
      { urlKey: "reasonid", stateKey: "appointmentType", default: false }
    ];

    values.forEach(item => {
      const def =
        item.default !== null || item.default !== undefined
          ? item.default
          : null;
      const urlValue = searchParams.has(item.urlKey)
        ? searchParams.get(item.urlKey)
        : def;
      if (urlValue) {
        initialValues[item.stateKey] = urlValue;
      }
    });
    initIndexValues(initialValues);
    isInitialized = true;
  }
  return initialValues;
};

export const initIndexValues = values => {
  const correspond = {
    idc: "idc",
    widgetType: "type",
    appointment: "appointment",
    token_rdv: "token",
    idlieu: "locationid",
    reasonid: "reasonid",
    base_url: "url_api",
    key_google_map: "google_geolocation_key",
    key_google: "google_auth_key",
    key_facebook: "facebook_auth_key",
    mode: "mode",
    lang: "lang",
    status_bloque_bouton: "status_bloque_bouton",
    partenaire: "partenaire",
    specialite: "specialite",
    noModal: "noModal"
  };
  const root = document.getElementById("root");

  for (const [key, value] of Object.entries(correspond)) {
    if (value in root.dataset) {
      values[key] = root.dataset[value];
    }
  }
  return values;
};

export const getReturnedValue = (key, defaultValue = "") => {
  const values = store.getState().returnedValue;
  return values[key] || (defaultValue || "");
};

export const deleteReturnedValue = key => {
  const values = store.getState().returnedValue;
  if (values[key]) {
    delete values[key];
  }
};

export const getCurrentStep = () => {
  return store.getState().activeStep;
};

let _fetcher, _fetcherSearchParams;

export const fetcher = (
  flush = false,
  additionalSearchParams = {},
  removeSearchParams = []
) => {
  if (!_fetcher || flush === true) {
    const values = initValues();
    if (removeSearchParams.length) {
      additionalSearchParams = {
        ...additionalSearchParams,
        ..._fetcherSearchParams
      };

      removeSearchParams.forEach(removeKey => {
        delete additionalSearchParams[removeKey];
      });
    }

    const searchParams = {
      ...{ cookie: values.cookie, idc: values.idc, provenance: "web" },
      ...additionalSearchParams
    };

    if (values.rdvToken) {
      searchParams["token_rdv"] = values.rdvToken;
    }
    if (values.optIn) {
      searchParams["optin"] = values.optIn;
    }
    if (values.idlieu) {
      searchParams["idlieu"] = values.idlieu;
    }
    if (values.idp) {
      searchParams["idp"] = values.idp;
    }
    if (values.idactivite) {
      searchParams["idactivite"] = values.idactivite;
    }
    if (values.lang && !searchParams["lang"]) {
      searchParams["lang"] = values.lang;
    }
    if (store.getState().locale && store.getState().locale.language) {
      searchParams["lang"] = store.getState().locale.language;
    }
    if (values.partenaire) {
      searchParams["partenaire"] = values.partenaire;
    }
    if (values.specialite) {
      searchParams["idspecialite"] = values.specialite;
    }
    if (values.appointmentType) {
      searchParams["idtyperdv"] = values.appointmentType;
    }
    _fetcherSearchParams = searchParams;
    _fetcher = ky.extend({
      prefixUrl: values.base_url,
      retry: 1,
      limit: 20,
      timeout: 30000,
      searchParams: _fetcherSearchParams,
      credentials: "same-origin",
      hooks: {
        beforeRequest: [
          request => {
            store.dispatch(startLoading());
            store.dispatch(setMessage(null));
            store.dispatch(resetMessageWithCode());
            if (
              store.getState().secret.dayId &&
              store.getState().secret.public
            ) {
              request.headers.set(
                "x-alx-secret-id",
                hash(
                  store.getState().secret.dayId,
                  store.getState().secret.public
                )
              );
              request.headers.set("x-alx-token", store.getState().userKey);
            } else if (values.dayId && values.publicKey && values.userKey) {
              request.headers.set(
                "x-alx-secret-id",
                hash(values.dayId, values.publicKey)
              );
              request.headers.set("x-alx-token", values.userKey);
            }
          }
        ],
        afterResponse: [
          responseChecker,
          ua,
          async (_request, _options, response) => {
            let json = await response.json();
            json = Array.isArray(json) ? json[0] : json;
            if (json.idjour && json.cles_public) {
              await localStorage.setItem("dayId", json.idjour);
              await localStorage.setItem("secretPublic", json.cles_public);
              await store.dispatch(
                secretUpdate({ dayId: json.idjour, public: json.cles_public })
              );
              if (json.token && values["iframe"]) {
                window.top.postMessage(
                  JSON.stringify({
                    dayid: json.idjour,
                    secretkey: json.cles_public,
                    userkey: json.token
                  }),
                  "*"
                );
              }
            }
            if (json.token) {
              await localStorage.setItem("token", json.token);
              await store.dispatch(setUserKey(json.token));
            }

            if (
              json.statut_connexion === "nop" &&
              Object.keys(store.getState().user.userData).length > 0
            ) {
              await store.dispatch(logOut());
            }
          }
        ]
      }
    });
  }
  return _fetcher;
};

export const initConfig = (
  reset = false,
  forceRdv = false,
  callbacks = {
    preInit: false,
    postInit: false
  }
) => {
  return (dispatch, getState) => {
    if (reset === true) {
      isInitialized = false;
    }
    dispatch(setReturnedValue(initValues()));
    dispatch(emptyBreadcrumbs());
    !reset && dispatch(localeSetLanguage(initValues().lang));

    if (initValues().provenance === "qrcode") {
      dispatch(originQrCode(true));
    }
    const root = document.getElementById("root");
    var url = root.dataset.url_api ? root.dataset.url_api + "/" : "./";

    if (initValues().mode === "compte" && !forceRdv) {
      fetch(url + "config.php?idc=" + initValues().idc)
        .then(response => response.json())
        .then(json => {
          initialValues["base_url"] = json.baseURL;
          fetcher(true);
          dispatch(getUserData(1));
          dispatch(isFirstConnectionPatientArea());
          dispatch(isPatientArea(true));
          dispatch(setConfig(json));
        });
    } else {
      const scenarioManager = instance(initValues().widgetType);
      dispatch(
        setFetcherAppointment(scenarioManager.getAvailableAppointment())
      );
      dispatch(setFetcherUrls(scenarioManager.getFetcherUrls()));
      fetch(url + "config.php?idc=" + initValues().idc)
        .then(response => response.json())
        .then(json => {
          initialValues["base_url"] = json.baseURL;
          fetcher(true);
          dispatch(setConfig(json));
          if ("accountOnly" in json && json.accountOnly) {
            dispatch(isFirstConnectionPatientArea());
            dispatch(getUserData());
            dispatch(isPatientArea(true));
            initialValues["noClose"] = true;
            return;
          }

          // build Steps
          const callbackData = { reset, forceRdv, initialValues };
          if (callbacks.preInit) {
            callbacks.preInit(dispatch, getState, callbackData);
          }

          const steps = scenarioManager.buildSteps(json.breadcrumbs);

          delete json.breadcrumbs;

          dispatch(buildFaq());
          dispatch(setSteps(steps));
          dispatch(setActiveStep({ step: 0, subStep: 0 }));
          dispatch(getUserData());
          dispatch(stopLoading());

          if (callbacks.postInit) {
            callbacks.postInit(dispatch, getState, callbackData);
          }
        })
        .catch(() => {
          dispatch(stopLoading());
        });
    }
  };
};

export const getQuestion = () => {
  return (dispatch, getState) => {
    const questionStepIndex = searchStepByCode(
      getState().steps,
      STEP_CODE_QUESTION
    );
    const isFirstQuestion = questionStepIndex === null;
    let questionId = getReturnedValue("idquestion");
    if (questionId) {
      const isRewind = getReturnedValue("isRewind", false);
      const previousQuestionId = getReturnedValue(questionId, false);
      const questionResponse = getReturnedValue("response", null);
      let repquestion = getReturnedValue("repquestion", null);
      const questionFilter = getReturnedValue("questionFilter", null);
      // always reset isRewind
      dispatch(setReturnedValue({ isRewind: false }));

      // in case of rewind use previous questionId related to this response
      // and re-set questionId with the previous one
      if (isRewind && previousQuestionId) {
        questionId = previousQuestionId;
        dispatch(setReturnedValue({ idquestion: questionId }));
      }
      // in case of rewind and if we already have a questionFilter,
      // we need to reset fetcher to remove the "filtrequestion" param
      if (isRewind && questionFilter) {
        fetcher(true);
        dispatch(setReturnedValue({ questionFilter: null }));
      }

      if (isRewind && !previousQuestionId) {
        dispatch(setActiveStep({ subStep: getState().activeStep.subStep - 1 }));
        return;
      }
      if (isRewind && repquestion) {
        dispatch(setReturnedValue({ repquestion: null }));
        repquestion = null;
      }
      const searchParams = { idquestion: questionId };
      if (questionResponse) {
        searchParams.reponse = questionResponse.toLowerCase();
        searchParams.id = getReturnedValue("questionIdNumber");
      }
      if (repquestion) {
        searchParams.id = getReturnedValue("questionIdNumber");
        searchParams.repquestion = repquestion;
      }

      fetcher()
        .get(
          questionResponse || repquestion
            ? getState().fetcher.urls.getResponse
            : getState().fetcher.urls.getQuestion,
          {
            searchParams
          }
        )
        .then(response => response.json())
        .then(json => {
          const exit =
            (Array.isArray(json) && !json.length) || json.sortie === "Y";
          const typeSortie = json.typesortie;
          if ((questionResponse || repquestion) && exit) {
            if (typeSortie === "link") {
              const subStep = createStep({
                component: {
                  type: GoToLink
                },
                data: {
                  fetchSource: () => ({
                    message: json.messagealert,
                    link: json.link
                  })
                }
              });
              dispatch(
                addSubStep(
                  getState().activeStep.step,
                  subStep,
                  getState().activeStep.subStep
                )
              );
              dispatch(nextStep(getState().steps));
            } else if (typeSortie === "popuprdv") {
              fetcher(true, { filtrequestion: json.id });
              const subStep = createStep({
                component: {
                  type: GoToLink
                },
                data: {
                  fetchSource: () => ({
                    message: json.messagealert,
                    isContinue: true
                  })
                }
              });
              dispatch(
                addSubStep(
                  getState().activeStep.step,
                  subStep,
                  getState().activeStep.subStep
                )
              );
              dispatch(nextStep(getState().steps));
            } else if (typeSortie === "rdv") {
              fetcher(true, { filtrequestion: json.id });
              dispatch(
                setReturnedValue({
                  idquestion: json.id,
                  response: null,
                  questionFilter: json.id,
                  [json.id]: questionId
                })
              );
              dispatch(nextStep(getState().steps));
            } else if (typeSortie === "upload") {
              dispatch(setReturnedValue({ upload: true }));
              const subscribe = searchStepByCode(
                getState().steps,
                STEP_CODE_IDENTIFY
              );
              dispatch(setActiveStep(subscribe));
            } else {
              const subStep = createStep({
                component: {
                  type: GoToLink
                },
                data: {
                  fetchSource: () => ({ message: json.messagealert })
                }
              });
              dispatch(
                addSubStep(
                  getState().activeStep.step,
                  subStep,
                  getState().activeStep.subStep
                )
              );
              dispatch(nextStep(getState().steps));
            }

            dispatch(stopLoading());
            return;
          }

          if (questionResponse) {
            dispatch(
              setReturnedValue({
                idquestion: json.id,
                response: null,
                [json.id]: questionId
              })
            );
            dispatch(getQuestion());
            return;
          }

          const QuestionComponent = getQuestionComponent(json.type_reponse);
          dispatch(setReturnedValue({ questionIdNumber: json.id }));
          const subStep = createStep({
            label: json.question,
            code: STEP_CODE_QUESTION,
            showLinkPriorityCode: isFirstQuestion ? true : false,
            user: getState().user,
            component: {
              type: QuestionComponent,
              label: json.question
            },
            data: {
              fetchSource: () => addFieldData("listeQuestion", json.reponse),
              formatSource: formatQuestion,
              keyValue: "listeQuestion"
            },
            returned: {
              key: "idquestion"
            },
            selfRemove: {
              group: GROUP_QUESTION_RESPONSE
            }
          });

          if (isFirstQuestion) {
            dispatch(
              addSubStep(
                getState().activeStep.step,
                subStep,
                getState().activeStep.subStep
              )
            );
            dispatch(nextStep(getState().steps));

            if (!exit) {
              dispatch(
                addSubStep(
                  getState().activeStep.step,
                  createLooperStep(),
                  getState().activeStep.subStep
                )
              );
            }
          } else {
            dispatch(
              replaceSubStep(
                questionStepIndex.step,
                subStep,
                questionStepIndex.subStep - 1
              )
            );
            dispatch(
              setActiveStep({
                step: questionStepIndex.step,
                subStep: questionStepIndex.subStep
              })
            );
          }

          dispatch(stopLoading());
        })
        .catch(() => {
          dispatch(stopLoading());
        });
    }
  };
};

const getQuestionComponent = type => {
  switch (type) {
    case "ouinon":
      return Ouinon;
    case "select":
      return QSelect;
    case "questionnaire":
      return Questionnaire;
    default:
      throw new Error("Unknown question type");
  }
};

export const validPriorityCode = code => {
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.controlPriorityCode, {
        searchParams: {
          codemotif: code,
          identifiantentite: getReturnedValue("idc")
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.result === "ok") {
          // reinit fetcher with additional parameter
          fetcher(true, { code_prioritaire: code });
          const fromActiveStep = { ...getState().activeStep };
          // drop useless steps
          const subStepToRemove = searchSelfRemoveSubStep(
            getState().steps,
            "priorityCode"
          );
          for (const key in subStepToRemove) {
            if (Object.prototype.hasOwnProperty.call(subStepToRemove, key)) {
              const [stepIndex, subStepIndex] = key.split(STEP_SEPARATOR);
              dispatch(deleteSubStep(+stepIndex, +subStepIndex));
            }
          }
          // search new active step
          const activeStep = searchStepByCode(
            getState().steps,
            "appointmentType"
          );
          if (activeStep) {
            const step = searchStep(getState().steps, activeStep);
            step.showLinkPriorityCode = false;
            dispatch(breadcrumbs(fromActiveStep, activeStep));
            dispatch(setActiveStep(activeStep));
          } else {
            // oups
          }
          dispatch(setShowCodePrioritaire(false));
        } else if (json.result === "nop") {
          dispatch(setMessage(json.message));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const addNewPerson = (values, isFromPatienArea = false) => {
  return (dispatch, getState) => {
    values.iduserp = isFromPatienArea
      ? getState().user.userData.userId
      : getReturnedValue("userId");
    fetcher()
      .get("ajax/add_user_annexe.php", { searchParams: values })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (isFromPatienArea) {
          dispatch(getLinkedAccounts());
        } else {
          dispatch(getListUserComplete());
        }
        if (json.success === 1) {
          if (parseInt(getState().returnedValue.nbPeople) === 1) {
            const usersSelected = getState().usersSelected;
            usersSelected.splice(0, usersSelected.length);
            dispatch(addUserSelected(json[0].id_user));
          } else if (
            getState().usersSelected.length !==
            parseInt(getState().returnedValue.nbPeople)
          ) {
            dispatch(addUserSelected(json[0].id_user));
          }
        } else {
          dispatch(setMessage(json.message_html));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getCodeSms = userId => {
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.getUser, {
        searchParams: { iduser: userId }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.codesms) {
          dispatch(codeSms(json.codesms));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const subscribe = values => {
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.subscribe, { searchParams: values })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;

        if (json.success === 1) {
          dispatch(setReturnedValue({ userId: json.iduser, userInfo: values }));

          dispatch(getCodeSms(json.iduser));

          dispatch(showDialogSms(true));
        } else {
          dispatch(setMessage(json.message_html));
        }

        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const contact = values => {
  let OS = "Unknown";
  let version = "";
  let all = "";
  const browserVersion = platform.version;
  if (navigator.userAgent.indexOf("Win") != -1) {
    OS = "Windows";
    all = navigator.userAgent.substring(
      navigator.userAgent.indexOf("Windows") + 7
    );
    version = all.substring(0, all.indexOf(";")).replace(/ /g, "");
  }
  if (navigator.userAgent.indexOf("Mac") != -1) {
    OS = "MacOS";
    all = navigator.userAgent.substring(
      navigator.userAgent.indexOf("MacOS") + 7
    );
    version = all.substring(0, all.indexOf(";")).replace(/ /g, "");
  }
  if (navigator.userAgent.indexOf("X11") != -1) {
    OS = "UNIX";
    all = navigator.userAgent.substring(
      navigator.userAgent.indexOf("UNIX") + 7
    );
    version = all.substring(0, all.indexOf(";")).replace(/ /g, "");
  }
  if (navigator.userAgent.indexOf("Linux") != -1) {
    OS = "Linux";
    all = navigator.userAgent.substring(
      navigator.userAgent.indexOf("Linux") + 7
    );
    version = all.substring(0, all.indexOf(";")).replace(/ /g, "");
  }
  console.log(navigator.userAgent);
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.contact, {
        searchParams: {
          ...values,
          ...{
            browsername: browserName,
            browserversion: browserVersion,
            os: OS,
            osversion: version
          }
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        dispatch(setMessage(json.message_html_ajax));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const isPaymentRequired = idUsers => {
  return dispatch => {
    fetcher()
      .post("ajax/check_paiment_motif_rdv.php", {
        searchParams: {
          id_motif_rdv: getReturnedValue("appointmentType"),
          idpraticien: getReturnedValue("practitioner"),
          nbr_rdv: getReturnedValue("nbPeople")
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.paiment !== "ok") {
          dispatch(editListUsers(idUsers));
        } else {
          dispatch(setPayment({ sum: json.montant, isRequired: true }));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const payConsultation = values => {
  return dispatch => {
    const formData = new FormData();
    Object.keys(values).map(key => formData.append(key, values[key]));
    fetcher()
      .post(
        `api/api_rdv/encaissement/${getReturnedValue("appointmentIdentifier")}`,
        {
          body: formData
        }
      )
      .then(response => response.json())
      .then(json => {
        if (json.result === "ok") {
          dispatch(setMessageWithCode({ text: json.message, code: 1 }));
          dispatch(
            setPaymentDetails({
              info: json.info,
              message: json.message,
              code: 1
            })
          );
        } else {
          dispatch(setMessageWithCode({ text: json.message, code: 0 }));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const editListUsers = idUsers => {
  let queryString = idUsers.map(value => "tab_id_user[]=" + value).join("&");
  queryString += `&cookie=${getReturnedValue("cookie")}&idc=${getReturnedValue(
    "idc"
  )}&iduserp=${getReturnedValue("userId")}&cgu_accepted=1`; //TODO remove cgu_accepted after
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.editListUsers, { searchParams: queryString })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.success === 1) {
          dispatch(getSummaryReport());
        } else {
          dispatch(setMessage(json.message_html));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const inscription = values => {
  values.identifiant_rdv = getReturnedValue("appointmentIdentifier");
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.subscribe, { searchParams: values })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;

        if (json.success === 1) {
          dispatch(setReturnedValue({ userId: json.iduser, userInfo: values }));

          const subStep = createStep({
            label: "",
            component: {
              type: ConfirmationSms,
              label: ""
            },
            data: {
              fetchSource: () => addFieldData("confirmation", json),
              keyValue: "confirmation"
            },
            returned: {
              key: "confirmation"
            }
          });

          dispatch(addSubStep(getState().activeStep.step, subStep));
          dispatch(
            setActiveStep({ subStep: getState().activeStep.subStep + 1 })
          );
        } else {
          dispatch(setMessage(json.message_html));
        }

        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const confirmAccountCreation = code => {
  return (dispatch, getState) => {
    const userId = getReturnedValue("userId");
    fetcher()
      .get(getState().fetcher.urls.confirm, {
        searchParams: {
          iduser: userId,
          code,
          identifiant_rdv: getReturnedValue("appointmentIdentifier")
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.success === 1) {
          if (getState().toValidateToken) {
            dispatch(getSummaryReport());
            dispatch(userArea(true));
          } else {
            dispatch(onLoggedIn(userId));
          }
        } else {
          dispatch(setMessage(json.message_html));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getListUserComplete = () => {
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.listUserComplete, {
        searchParams: {
          iduserp: getReturnedValue("userId"),
          identifiant_rdv: getReturnedValue("appointmentIdentifier")
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        dispatch(addFieldData("userDetails", json.attached_persons));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const alterAppointment = () => {
  return (dispatch, getState) => {
    fetcher()
      .get(getState().fetcher.urls.alterAppointment, {
        searchParams: {
          iduser: getReturnedValue("userId")
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;

        dispatch(setMessage(json.message_html));
        if (json.success === 1) {
          dispatch(getSummaryReport());
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getSummaryReport = (incStep = 1) => {
  return (dispatch, getState) => {
    const teleconsul =
      getState().returnedValue.typeConsultation === "teleconsult" ? "ok" : "";
    fetcher()
      .get(getState().fetcher.urls.recapRdv, {
        searchParams: {
          telconsul: teleconsul,
          identifiant_rdv: getReturnedValue("appointmentIdentifier")
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.ctrlcontrole === "nop") {
          let error_message = `<div style="text-align:left"><h3>Une ou des erreurs sont survenues :</h3>`;

          if (Array.isArray(json.ctrl_message)) {
            error_message += "<ul>";
            json.ctrl_message.forEach(message => {
              error_message += `<li>${message}</li>`;
            });
            error_message += "</ul>";
          } else {
            error_message += `<div>${json.ctrl_message}</div>`;
          }
          error_message += "</div>";
          dispatch(setMessage(error_message));
        } else {
          const subStep = createStep({
            label: "",
            component: {
              type: SummaryReport,
              label: ""
            },
            data: {
              fetchSource: () => addFieldData("summary", json),
              keyValue: "summary"
            },
            code: "summary"
          });

          dispatch(
            setActiveStep({
              step: getState().activeStep.step + incStep,
              subStep: 0
            })
          );
          dispatch(addSubStep(getState().activeStep.step, subStep));
        }

        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const validateRdv = userId => {
  return dispatch => {
    fetcher()
      .get("ajax/validation_rdv.php", {
        searchParams: {
          iduser: userId,
          identifiant_rdv: getReturnedValue("appointmentIdentifier")
        }
      })
      .then(response => response.json())
      .then(() => {
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const connexion = values => {
  const formData = new FormData();
  Object.keys(values).map(key => formData.append(key, values[key]));

  formData.append("idc", initValues().idc);
  formData.append("cookie", initValues().cookie);
  formData.append("lang", initValues().lang);

  return dispatch => {
    fetcher()
      .post("ajax/connexion_widget_post.php", { body: formData })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.success === 1) {
          document.cookie = `workaround_user_session_id=${json.cle_user}`; // @todo remove me please
          dispatch(onLoggedIn(json.iduser));
        } else {
          dispatch(setMessage(json.message_ajax));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const forgotPassword = (values, success) => {
  const formData = new FormData();
  Object.keys(values).map(key => formData.append(key, values[key]));
  return dispatch => {
    fetcher()
      .post("ajax/envoi_mdp_compte_widget.php", { body: formData })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        success(json.message_ajax, json.success);
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const buildFaq = () => {
  return dispatch => {
    fetcher()
      .get("cache_ajax/faq_widget.php")
      .then(response => response.json())
      .then(json => {
        dispatch(faq(json));
      });
  };
};

export const buildCgu = () => {
  return dispatch => {
    fetcher()
      .get("ajax/recup_cgu.php")
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        dispatch(cgu(json.message_defaut));
        dispatch(stopLoading());
      });
  };
};

export const goToNextStep = (
  key,
  values,
  byPassed = false,
  value = null,
  label = null
) => {
  return (dispatch, getState) => {
    dispatch(setStepByPass(getState().activeStep, byPassed));

    dispatch(addFieldData(key, values));

    if (byPassed) {
      const element = { textItem: label, stepItem: getState().activeStep };
      if (label) {
        dispatch(setItemBreadcrumbs(element));
      }

      dispatch(setReturnedValue({ [key]: value }));
      dispatch(nextStep(getState().steps));
    } else {
      dispatch(stopLoading());
    }
  };
};

export const notificationAppointment = ({
  fromDate,
  toDate,
  heure_debut_avertir,
  heure_fin_avertir,
  jours_avertir
}) => {
  return dispatch => {
    fetcher()
      .get("ajax/enregistre_demande_desistement.php", {
        searchParams: {
          date_debut_avertir: fromDate,
          date_fin_avertir: toDate,
          jours_avertir: jours_avertir,
          heure_debut_avertir: heure_debut_avertir,
          heure_fin_avertir: heure_fin_avertir
        }
      })
      .then(response => response.json())
      .then(json => {
        dispatch(setMessage(json[0].message_html));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const logOut = () => {
  return dispatch => {
    document.cookie = "workaround_user_session_id="; // @todo remove me please

    fetcher().get("ajax/deconnexion_ajax.php");
    dispatch(allInfoUser({}));
    dispatch(resetUserData());
  };
};

export const getFirstStepNotBypassed = () => {
  let stepsList = store.getState().steps;
  let { firstStep, firstSubStep } = 0;
  if (Object.keys(stepsList).length > 0) {
    stepsList = Object.values(stepsList);
    firstStep = stepsList.findIndex(step => {
      if (step.children) {
        firstSubStep = step.children.findIndex(child => child.byPass === false);
      }
      return step.byPass === false;
    });
  }
  return { step: firstStep, subStep: firstSubStep };
};

export const getListAppointments = () => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";

    fetcher()
      .get("ajax/liste_rdv_compte_ajax.php", {
        searchParams: { id_user: userId }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.liste_rdv) {
          const myListAppointments = json.liste_rdv.map(item => {
            return {
              lastName: item.nom_patient,
              firstName: item.prenom_patient,
              infoDoctor: item.infodoc,
              civilityDoctor: item.abr_proffession,
              lastNameDoctor: item.tab_remplacant[0]
                ? item.tab_remplacant[0].nom_user
                : item.nom_praticien,
              firstNameDoctor: item.tab_remplacant[0]
                ? item.tab_remplacant[0].prenom_user
                : item.prenom_praticien,
              pictureDoctor: item.tab_remplacant[0]
                ? item.tab_remplacant[0].photo_user
                : item.photo_praticien,
              motif: item.motif,
              date: item.jourliteral,
              Hour: item.heure_rdv,
              appointmentId: item.id_rendez_vous,
              numDay: item.jour_date_rdv,
              month: item.mois_date_rdv,
              year: item.annee_date_rdv,
              day: item.num_date_rdv,
              token: item.token_rdv,
              city: item.ville_lieux,
              cp: item.code_postal_lieux,
              address: item.adresse_lieux,
              tel: item.tel_lieux,
              urlEdit: item.url_deplacer,
              activity: item.libelle_type_activite,
              deletable: item.deletable
            };
          });
          dispatch(myAppointments(myListAppointments));
        }
        dispatch(stopLoading());
      });
  };
};

export const deleteAppointment = appointmentId => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    fetcher()
      .get("ajax/confirmation_annulation.php", {
        searchParams: { id_rdv: appointmentId, idenuser: userId }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.success === 1) {
          dispatch(getListAppointments());
        } else {
          dispatch(setMessageWithCode({ text: json.message_html, code: -1 }));
        }
        dispatch(stopLoading());
      });
  };
};

export const paramsToString = params => {
  const keys = Object.keys(params);
  const values = Object.values(params);
  var result = "";
  for (var x = 0; x < keys.length; x++) {
    if (x === 0) {
      result += "?";
    } else {
      result += "&";
    }
    result += keys[x] + "=" + values[x];
  }
  return result;
};

export const editAppointment = (
  doctorId,
  professionId,
  placeId,
  motifId,
  urlEdit = "",
  appointmentId
) => {
  return (dispatch, getState) => {
    let newUrl = "";
    fetcher()
      .get("ajax/gest_link_code.php", {
        searchParams: { id: appointmentId }
      })
      .then(response => response.json())
      .then(json => {
        if (json.url) {
          newUrl = json.url;
          const postInit = (dispatch, getState) => {
            const step = searchStepByCode(getState().steps, "nbPeopleCode");
            dispatch(
              setReturnedValue({
                profession: professionId,
                practitioner: doctorId,
                appointmentLocation: placeId,
                appointmentType: motifId
              })
            );
            dispatch(setActiveStep(step));
          };
          if (newUrl !== "") {
            localStorage.setItem("dayId", getState().secret.dayId);
            localStorage.setItem("secretPublic", getState().secret.public);
            localStorage.setItem("token", getState().userKey);
            if (initValues().iframe) {
              window.top.postMessage(
                JSON.stringify({
                  url: newUrl,
                  mode: "navigate",
                  dayid: getState().secret.dayId,
                  secretkey: getState().secret.public,
                  userkey: getState().userKey
                }),
                "*"
              );
            } else {
              window.location.href = newUrl;
            }
          } else {
            dispatch(initConfig(true, true, { postInit }));
            dispatch(isPatientArea(false));
          }
        }
      });
    const postInit = (dispatch, getState) => {
      const step = searchStepByCode(getState().steps, "nbPeopleCode");
      dispatch(
        setReturnedValue({
          profession: professionId,
          practitioner: doctorId,
          appointmentLocation: placeId,
          appointmentType: motifId
        })
      );
      dispatch(setActiveStep(step));
    };
    if (urlEdit !== "") {
      localStorage.setItem("dayId", getState().secret.dayId);
      localStorage.setItem("secretPublic", getState().secret.public);
      localStorage.setItem("token", getState().userKey);

      if (initValues().iframe) {
        window.top.postMessage(
          JSON.stringify({
            url: urlEdit,
            mode: "navigate",
            dayid: getState().secret.dayId,
            secretkey: getState().secret.public,
            userkey: getState().userKey
          }),
          "*"
        );
      } else {
        window.location.href = urlEdit;
      }
    } else {
      dispatch(initConfig(true, true, { postInit }));
      dispatch(isPatientArea(false));
    }
  };
};

export const getLinkedAccounts = () => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";

    fetcher()
      .get("ajax/get_user_annexe_cp_ajax.php", {
        searchParams: { iduserp: userId }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.attached_persons) {
          const listLinkedAccounts = json.attached_persons.map(item => {
            return {
              lastName: `${item.nom_user}`,
              firstName: `${item.prenom_user}`,
              relationship: item.parent_user || "",
              relationship2: item.identifiant_champ_vrac || "",
              dob: `${item.datenaissance_user}`,
              civility: `${item.abreviation_civilite}`,
              userId: item.identifiant_user
            };
          });
          dispatch(linkedAccounts(listLinkedAccounts));
        }
        dispatch(stopLoading());
      });
  };
};

export const getHistory = () => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";

    fetcher()
      .get("ajax/historique_rdv_ajax.php", {
        searchParams: { id_user: userId }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.liste_rdv) {
          const history = json.liste_rdv.map(item => {
            return {
              lastName: item.nom_patient,
              firstName: item.prenom_patient,
              infoDoctor: item.infodoc,
              lastNameDoctor: item.tab_remplacant[0]
                ? item.tab_remplacant[0].nom_user
                : item.nom_praticien,
              firstNameDoctor: item.tab_remplacant[0]
                ? item.tab_remplacant[0].prenom_user
                : item.prenom_praticien,
              pictureDoctor: item.tab_remplacant[0]
                ? item.tab_remplacant[0].photo_user
                : item.photo_praticien,
              motif: item.motif,
              date: item.jourliteral,
              Hour: item.heureaff_prise_rendez_vous,
              appointmentId: item.identification_rdv,
              professionId: item.idprofession,
              doctorId: item.id_docteur,
              placeId: item.id_lieu,
              motifId: item.id_motif,
              isUploadFile: item.bfileupload === "ok" ? true : false,
              isCancelled: item.supplogique_prise_rendez_vous === "Y",
              isAnon: item.is_anonyme === "Y",
              isReusable: item.activ_prise_web_all_type_rdv === "Y",
              moveUrl: item.url_deplacer
            };
          });

          dispatch(myHistory(history));
        }
        dispatch(stopLoading());
      });
  };
};

export const getFiles = () => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";

    fetcher()
      .get("ajax/historique_document_ajax.php", {
        searchParams: { id_user: userId }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.liste_document) {
          const files = json.liste_document.map(item => {
            return {
              fileName: item.monfile_file_rdv,
              fileLink: item.file,
              date: item.dateenreg,
              id: item.guid_file_rdv
            };
          });

          dispatch(filesDownload(files));
        }
        dispatch(stopLoading());
      });
  };
};

export const getAllInfoUser = () => {
  return async (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    await fetcher()
      .get("ajax/get_info_user.php", {
        searchParams: {
          iduser: userId
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json) {
          dispatch(allInfoUser(json));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const saveInfosUser = (values, userId = null, isSubmitSms = false) => {
  return (dispatch, getState) => {
    let id = "";
    if (userId) {
      id = userId;
    } else {
      id = getState().user.userData ? getState().user.userData.userId : "";
    }
    values["iduser"] = id;
    if (isSubmitSms) {
      values["envoisms"] = "envoisms";
    }
    const formData = new FormData();
    Object.keys(values).map(key => formData.append(key, values[key]));

    formData.append("idc", initValues().idc);
    fetcher()
      .post("ajax/set_info_user_plus_react.php", { body: formData })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (isSubmitSms) {
          dispatch(getCodeSms(userId));
        }
        if (json.success === 0) {
          dispatch(setMessageWithCode({ text: json.message_html, code: -1 }));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const editPassword = values => {
  return (dispatch, getState) => {
    values["iduser"] = getState().user.userData
      ? getState().user.userData.userId
      : "";
    const formData = new FormData();
    Object.keys(values).map(key => formData.append(key, values[key]));
    fetcher()
      .post("ajax/update_mdp_user.php", { body: formData })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        dispatch(
          setMessageWithCode({ text: json.message_ajax, code: json.success })
        );
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const switchWidgetAppointment = (token = null) => {
  return (dispatch, getState) => {
    if (getState().appointmentUrl && getState().appointmentUrl !== "") {
      var url = getState().appointmentUrl;
      url += token ? "?token_rdv=" + token + "#/deplacer" : "";
      if (initValues().iframe) {
        window.top.postMessage(
          JSON.stringify({
            url: url,
            mode: "navigate",
            dayid: getState().secret.dayId,
            secretkey: getState().secret.public,
            userkey: getState().userKey
          }),
          "*"
        );
      } else {
        window.location.href = url;
      }
    } else {
      let searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has("mode")) {
        searchParams.delete("mode");
      }
      window.location.search = searchParams;
      dispatch({ type: RESET_APP });
      dispatch(isPatientArea(false));
      if (token) {
        fetcher(true, { token_rdv: token });
      }
    }
  };
};

export const switchWidgetPatientArea = () => {
  return dispatch => {
    dispatch(isPatientArea(true));
  };
};

export const getSettings = () => {
  return dispatch => {
    var url = initValues().base_url ? initValues().base_url + "/" : "./";
    fetch(url + "config.php?idc=" + initValues().idc)
      .then(response => response.json())
      .then(json => {
        initialValues["base_url"] = json.baseURL;
        fetcher(true);
        dispatch(setConfig(json));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const deleteUserAnnex = userId => {
  return dispatch => {
    fetcher()
      .get("ajax/del_user_annexe.php", {
        searchParams: {
          iduser: userId
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.success === 1) {
          dispatch(getLinkedAccounts());
        } else {
          dispatch(
            setMessageWithCode({
              text: json.message_simple,
              code: -1
            })
          );
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const editUserAnnex = user => {
  return dispatch => {
    fetcher()
      .get("ajax/edit_user_annexe.php", {
        searchParams: user
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        if (json.success === 1) {
          dispatch(getLinkedAccounts());
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const scanQrCode = () => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";

    fetcher()
      .get("ajax/get_rdv_jour.php", {
        searchParams: {
          identifiant_user: userId,
          identifiant_entite: getReturnedValue("idc")
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.length === 1) {
          const listPersons = formatWaitingRoomPersons(json);
          dispatch(
            infoWaitingRoom({
              gotoRoom: true,
              listPersons: listPersons
            })
          );
        } else {
          const listPersons = formatWaitingRoomPersons(json);
          if (listPersons.length) {
            dispatch(
              infoWaitingRoom({
                listPersons: listPersons
              })
            );
          }
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const validatePersonsWaitingRoom = appointmentIds => {
  let queryString = appointmentIds
    .map(value => "tab_id_appointment[]=" + value)
    .join("&");
  queryString += `&cookie=${getReturnedValue("cookie")}&idc=${getReturnedValue(
    "idc"
  )}`;
  return (dispatch, getState) => {
    fetcher()
      .get("ajax/passe_salle_attente.php", { searchParams: queryString })
      .then(response => response.json())
      .then(() => {
        let listPersons = getState().waitingRoom.listPersons;
        listPersons = listPersons.map(item => {
          if (appointmentIds.includes(item.appointmentId)) {
            item.isInWaitingRoom = true;
          }
          return item;
        });
        dispatch(
          infoWaitingRoom({
            gotoRoom: true,
            listPersons: listPersons
          })
        );
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const editUserAttached = values => {
  return dispatch => {
    fetcher()
      .get("ajax/modif_user_annexe.php", { searchParams: values })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        dispatch(
          setMessageWithCode({ text: json.message_simple, code: json.success })
        );
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const cancelAppointment = () => {
  return dispatch => {
    dispatch(resetUsersSelected());
    fetcher()
      .get("ajax/del_rdv_widget_ajax.php", {
        searchParams: {
          identifiant_rdv: getReturnedValue("appointmentIdentifier"),
          identifiant_user: getReturnedValue("userId")
        }
      })
      .then(response => response.json())
      .then(() => {
        deleteReturnedValue("appointmentIdentifier");
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
    dispatch(logOut());
  };
};

export const downloadFiles = (id, doctorId) => {
  return dispatch => {
    fetcher()
      .get("ajax/get_file_rdv.php", {
        searchParams: {
          idrdv: id,
          identifiant_praticien: doctorId
        }
      })
      .then(response => response.json())
      .then(json => {
        dispatch(myFiles(json));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const searchPatients = searchString => {
  return dispatch => {
    fetcher()
      .get("ajax/liste_patient_journee_ajax.php", {
        searchParams: searchString
      })
      .then(response => response.json())
      .then(json => {
        let patients = [];
        if (json[0].status === "0") {
          dispatch(setMessage(json[0].message));
        } else {
          patients = json.map(item => {
            return {
              lastName: item.nom_patient,
              firstName: item.prenom_patient,
              lastNameDoctor: item.nom_docteur,
              firstNameDoctor: item.prenom_docteur,
              hour: item.heure_rdv,
              appointmentId: item.identification_rdv
            };
          });
        }
        dispatch(listPatients(patients));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const validPresence = appointmentIds => {
  let queryString = appointmentIds.map(value => "idp[]=" + value).join("&");
  queryString += `&cookie=${getReturnedValue("cookie")}&idc=${getReturnedValue(
    "idc"
  )}`;
  return dispatch => {
    fetcher()
      .get("ajax/valider_presence_patient_ajax.php", {
        searchParams: queryString
      })
      .then(response => response.json())
      .then(json => {
        if (json) {
          const listPersons = formatWaitingRoomPersonsExternal(json);
          dispatch(
            infoWaitingRoom({
              gotoRoom: true,
              listPersons: listPersons
            })
          );
        }

        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const deleteWaitingRoom = appointmentIds => {
  let queryString = appointmentIds.map(value => "idp[]=" + value).join("&");
  queryString += `&cookie=${getReturnedValue("cookie")}&idc=${getReturnedValue(
    "idc"
  )}`;
  return (dispatch, getState) => {
    fetcher()
      .get("ajax/retrait_presence_patient_ajax.php", {
        searchParams: queryString
      })
      .then(response => response.json())
      .then(() => {
        let listPersons = getState().waitingRoom.listPersons;
        listPersons = listPersons.map(item => {
          if (appointmentIds.includes(item.appointmentId)) {
            item.isInWaitingRoom = false;
          }
          return item;
        });
        dispatch(
          infoWaitingRoom({
            gotoRoom: true,
            listPersons: listPersons
          })
        );
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const checkLocatePatient = (lat, lng) => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    /*const lat = "43.7042574";
    const lng = "-1.0582207";*/

    fetcher()
      .get("ajax/check_presence_gps.php", {
        searchParams: {
          identifiant_user: userId,
          lat: lat,
          long: lng,
          identifiant_entite: getReturnedValue("idc")
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.result === "nop") {
          dispatch(setMessage(json.message));
        } else {
          if (json.length === 1) {
            const listPersons = formatWaitingRoomPersons(json, true);
            dispatch(
              infoWaitingRoom({
                gotoRoom: true,
                listPersons: listPersons
              })
            );
          } else {
            const listPersons = formatWaitingRoomPersons(json);
            if (listPersons.length) {
              dispatch(
                infoWaitingRoom({
                  gotoRoom: true,
                  listPersons: listPersons
                })
              );
            }
          }
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const uploadFile = files => {
  return () => {
    const formData = new FormData();
    formData.append("rdvfile", files[0].file);

    fetcher()
      .post(`api_rdv/test.php`, {
        body: formData
      })
      .then(response => response.json())
      .then(() => {});
  };
};

export const searchPatient = (name = "") => {
  fetcher()
    .get(`ajax/recherche_fiche_patient_auto_complete.php`, {
      searchParams: {
        bypassidentcentre: getReturnedValue("idc"),
        term: name
      }
    })
    .then(response => response.json())
    .then(() => {});
};

export const getDetailPatient = patientId => {
  return dispatch => {
    fetcher()
      .get("ajax/get_info_patient.php", {
        searchParams: {
          idpatient: patientId
        }
      })
      .then(response => response.json())
      .then(json => {
        json[0].idPatient = patientId;
        dispatch(detailPatient(json[0]));
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const savePatientFromAdmin = values => {
  return (dispatch, getState) => {
    values.id_patient = getState().detailPatient.idPatient;
    fetcher()
      .get("ajax/enregistrement_patient.php", {
        searchParams: values
      })
      .then(response => response.json())
      .then(json => {
        dispatch(confirmAppointmentAdmin(json[0].idpatient));
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const confirmAppointmentAdmin = patientId => {
  return dispatch => {
    fetcher()
      .get("ajax/confirmation_rdv_backoffice.php", {
        searchParams: {
          iduser: patientId,
          idrdv: getReturnedValue("appointmentIdentifier"),
          versionapp: 1
        }
      })
      .then(response => response.json())
      .then(() => {
        dispatch(getSummaryReport());
        dispatch(userArea(true));
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const setSocialSecurityFunc = (
  SocialSecurityId,
  patientId,
  address = null,
  codePostal = null,
  ville = null,
  medecinTraitant = null
) => {
  return (dispatch, getState) => {
    fetcher()
      .get("ajax/set_num_sociale.php", {
        searchParams: {
          numsecu: SocialSecurityId,
          id_user: patientId,
          address: address,
          codePostal: codePostal,
          ville: ville,
          medecinTraitant: medecinTraitant
        }
      })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        dispatch(setSocialSecurity(json.success === 1 ? 1 : 2));
        if (json.success === 1) {
          const currentIndex = getState().usersSelected.indexOf(patientId);
          if (currentIndex === -1) {
            dispatch(addUserSelected(patientId));
          } else {
            dispatch(removeUserSelected(patientId));
          }
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const getRecallStatus = () => {
  return async (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    await fetcher()
      .get("ajax/recall_status.php", {
        searchParams: {
          iduser: userId,
          idc: getReturnedValue("idc")
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success === "ok") {
          dispatch(myParams({ recall: !json.blacklisted }));
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};

export const getRecallDocument = () => {
  return async (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    await fetcher()
      .get("ajax/recall_document.php", {
        searchParams: {
          iduser: userId,
          idc: getReturnedValue("idc")
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success === "ok") {
          dispatch(
            myParams({ recallDocument: json.notification_document === "1" })
          );
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};

export const getRecallShare = () => {
  return async (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    await fetcher()
      .get("ajax/partage_compte_groupe.php", {
        searchParams: {
          iduser: userId,
          idc: getReturnedValue("idc")
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success === "ok") {
          dispatch(
            myParams({ recallShare: json.partage_compte_groupe === "1" })
          );
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};

export const getRecallCommunication = () => {
  return async (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    await fetcher()
      .get("ajax/recall_communication_partenaire.php", {
        searchParams: {
          iduser: userId,
          idc: getReturnedValue("idc")
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success === "ok") {
          dispatch(
            myParams({
              recallCommunication: json.notification_partenaire === "1"
            })
          );
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};

export const setRecallStatus = (phoneNumber, status) => {
  return dispatch => {
    fetcher()
      .put("ajax/recall_status.php", {
        body: JSON.stringify({
          phone_num: phoneNumber,
          idc: getReturnedValue("idc"),
          blacklist: !status
        })
      })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch(myParams({ recall: status }));
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};

export const setRecallDocument = status => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    fetcher()
      .put("ajax/recall_document.php", {
        body: JSON.stringify({
          idc: getReturnedValue("idc"),
          notification_document: status ? "1" : "0",
          iduser: userId
        })
      })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch(myParams({ recallDocument: status }));
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};

export const setRecallShare = status => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    fetcher()
      .put("ajax/partage_compte_groupe.php", {
        body: JSON.stringify({
          idc: getReturnedValue("idc"),
          partage_compte_groupe: status ? "1" : "0",
          iduser: userId
        })
      })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch(myParams({ recallShare: status }));
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};

export const setRecallCommunication = status => {
  return (dispatch, getState) => {
    const userId = getState().user.userData
      ? getState().user.userData.userId
      : "";
    fetcher()
      .put("ajax/recall_communication_partenaire.php", {
        body: JSON.stringify({
          idc: getReturnedValue("idc"),
          notification_partenaire: status ? "1" : "0",
          iduser: userId
        })
      })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch(myParams({ recallCommunication: status }));
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};

export const getNewslettersStatus = () => {
  return async dispatch => {
    await fetcher()
      .get("ajax/newsletter_status.php")
      .then(response => response.json())
      .then(json => {
        if (json.success === "ok") {
          dispatch(myParams({ newsletters: json.bnewsletter }));
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};

export const setNewslettersStatus = (phoneNumber, status) => {
  return dispatch => {
    fetcher()
      .put("ajax/newsletter_status.php", {
        body: JSON.stringify({
          phone_num: phoneNumber,
          idc: getReturnedValue("idc"),
          acceptnewsletter: status ? "Y" : "N"
        })
      })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          dispatch(myParams({ newsletters: status }));
        } else if (json.message) {
          dispatch(setMessage(json.message));
        } else {
          dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(setMessage(translator()._("W_FETCH_ERROR")));
        dispatch(stopLoading());
      });
  };
};
